module.exports = __webpack_public_path__ + "mainassets/img/tile-2-1h.d512c3b2.jpg";